import "./whatsapp.scss";
import { FaWhatsapp } from "react-icons/fa";
import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

export default function WhatsAppButton() {
  const number = "573137283858"; // Reemplaza con el número de WhatsApp deseado. Producción: 573137283858 - Pruebas: 573106329879
  const [language, setLanguage] = useState(localStorage.getItem("lang") || "es");
  const location = useLocation();

  useEffect(() => {
    const handleLanguageChange = () => {
      setLanguage(localStorage.getItem("lang") || "es");
    };

    window.addEventListener("languageChange", handleLanguageChange);

    return () => window.removeEventListener("languageChange", handleLanguageChange);
  }, []);

  // El texto junto al ícono solo debe verse en la sección de Programas y
  // Campañas ("/program"); en el resto del sitio el botón se muestra
  // como un ícono solo.
  const isProgramsSection = location.pathname.startsWith("/program");

  // Mensaje que llega ya escrito en WhatsApp cuando alguien toca el botón,
  // para que el equipo de la fundación sepa de una que la persona quiere apadrinar a un niño.
  const message = language === "es"
    ? "Hola, quiero apadrinar a un niño"
    : "Hello, I would like to sponsor a child";

  return (
    <a
        href={`https://wa.me/${number}?text=${encodeURIComponent(message)}`}
        className={`whatsapp-float${isProgramsSection ? " whatsapp-expanded" : ""}`}
        target="_blank"
        rel="noopener noreferrer"
    >
        <FaWhatsapp size={32} />
        <span className="whatsapp-label">
          {language === "es" ? "Quiero apadrinar un niño" : "I want to sponsor a child"}
        </span>
    </a>
  );
}
